import {
  PaginatedPriorAuthorization,
  PriorAuthorization,
  PriorAuthorizationDetail,
  PriorAuthorizationNavigatorItem,
} from "@/src/models/documents/prior-authorization/prior-authorization";
import {
  PriorAuthorizationComms,
  priorAuthorizationCommsListResponseSchema,
} from "@/src/models/documents/prior-authorization/prior-authorization-comms";
import { PaginatedPriorAuthorizationFiltersParams } from "@/src/repo/prior-authorization/prior-authorization-list";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getAllPriorAuthorizations(): Promise<Record<string, PriorAuthorizationNavigatorItem>> {
  return fetchJSON<Record<string, PriorAuthorizationNavigatorItem>>("/api/prior-authorizations");
}

export async function getPriorAuthorizationsByReferralId(referralId: string): Promise<PriorAuthorization[]> {
  return fetchJSON<PriorAuthorization[]>(`/api/referrals/${referralId}/prior-authorizations`);
}

export interface PaginatedPriorAuthorizationsResponse {
  priorAuthorizations: PaginatedPriorAuthorization[];
  totalCount: number;
  hasMore: boolean;
  page: number;
  pageSize: number;
}

export async function getPaginatedPriorAuthorizations(
  params: PaginatedPriorAuthorizationFiltersParams
): Promise<PaginatedPriorAuthorizationsResponse> {
  const { page = 0, pageSize = 30, sortBy, sortOrder, query, ...columnFilters } = params;

  const searchParams = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString(),
  });

  for (const [key, values] of Object.entries(columnFilters)) {
    if (Array.isArray(values) && values.length > 0) {
      searchParams.set(key, values.join(","));
    } else if (values !== undefined && values !== null) {
      searchParams.set(key, String(values));
    }
  }

  if (sortBy) {
    searchParams.set("sortBy", sortBy);
  }

  if (sortOrder) {
    searchParams.set("sortOrder", sortOrder);
  }

  if (query) {
    searchParams.set("query", query);
  }

  return fetchJSON<PaginatedPriorAuthorizationsResponse>(
    `/api/prior-authorizations/paginated?${searchParams.toString()}`
  );
}

export async function getPriorAuthorizationByDisplayId(authDisplayId: string): Promise<PriorAuthorizationDetail> {
  return fetchJSON<PriorAuthorizationDetail>(`/api/prior-authorizations/${authDisplayId}`);
}

export async function getPriorAuthorizationComms(authDisplayId: string): Promise<PriorAuthorizationComms[]> {
  const data = await fetchJSON<PriorAuthorizationComms[]>(`/api/prior-authorizations/${authDisplayId}/comms`);

  return priorAuthorizationCommsListResponseSchema.parse(data);
}
